module.exports = __webpack_public_path__ + "static/media/chalkbutton.bec6a306.png";